import(/* webpackMode: "eager" */ "/vercel/path0/src/app/terms-and-condition/page.js")